import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditableText from "@/Components/EditableText";
import ImageUploader from "../../components/ImageUploader";
import { uploadServicesPic } from "Utility/UploadFile";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import "./Styles/Animation.css";
import { useSelector } from "react-redux";
import { getThemeColor } from "Store/reducers/Auth/AuthSlice";

export const WidgetRenderer = ({
  widgets,
  onWidgetEdit,
  onWidgetDelete,
  username,
}) => {
  const onImageUpload = async (index, file) => {
    const uploadResult = await uploadServicesPic(file, username);
    onWidgetEdit({ index, key: "s3key", value: uploadResult?.key });
  };

  const themeColorString = useSelector(getThemeColor);
  let themeColor;

  try {
    themeColor = JSON.parse(themeColorString);
  } catch (error) {
    console.error(
      "Failed to parse themeColor in WidgetRenderer:",
      themeColorString,
      error
    );
    themeColor = {
      background: "#E6E6E6",
      text: "#333C4D",
      btnBg: "#ffffff",
      btnText: "#333C4D",
    };
  }

  const DeleteWidgetsIcon = ({ itemIndex }) => {
    return (
      <FontAwesomeIcon
        icon={faTrash}
        onClick={() => onWidgetDelete(itemIndex)}
        style={{
          backgroundColor: themeColor?.background,
          color: themeColor?.text,
        }}
        className="cursor-pointer border border-inherit p-[6px] h-3 w-3 rounded-full 
          absolute top-[-10px] right-[-5px] z-10 text-[13px]"
      />
    );
  };

  return (
    <div className="w-full mb-60">
      {/* Grid layout for the widgets */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 md:gap-5 lg:gap-6">
        {widgets.map((widget, index) => {
          switch (widget?.type) {
            case "title":
              // Title will take full width (1 column on all screen sizes)
              return (
                <div
                  className="w-full col-span-1 sm:col-span-2 lg:col-span-3 relative animate-fade-slide-in"
                  key={widget?.id}
                >
                  <EditableText
                    className="font-bold w-full text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl justify-self-stretch"
                    onEditDone={(e) =>
                      onWidgetEdit({ index, key: "title", value: e["title"] })
                    }
                    name="title"
                    key="title"
                    placeholder="Enter Title"
                    editModeOn={widget.isEditing}
                    autoFocus
                  >
                    {widget?.title}
                  </EditableText>
                  <DeleteWidgetsIcon itemIndex={index} />
                </div>
              );
            case "discription":
              // Discription will take full width (1 column on all screen sizes)
              return (
                <div
                  className="w-full col-span-1 sm:col-span-2 lg:col-span-3 relative animate-fade-slide-in"
                  key={widget?.id}
                >
                  <EditableText
                    className="w-full text-sm sm:text-base md:text-lg lg:text-xl justify-self-stretch"
                    onEditDone={(e) =>
                      onWidgetEdit({
                        index,
                        key: "discription",
                        value: e["discription"],
                      })
                    }
                    name="discription"
                    key="discription"
                    placeholder="Enter Discription"
                    editModeOn={widget.isEditing}
                    autoFocus
                  >
                    {widget?.discription}
                  </EditableText>
                  <DeleteWidgetsIcon itemIndex={index} />
                </div>
              );
            case "image":
              return (
                <div
                  key={widget?.id}
                  className={`relative animate-fade-slide-in border-radius aspect-square shadow-sm ${
                    !widget.s3key && "border"
                  }`}
                  style={{ borderColor: themeColor.text }}
                >
                  <DeleteWidgetsIcon itemIndex={index} />
                  <ImageUploader
                    key={`index-${index}`}
                    preview={widget?.s3key}
                    className="render-image-class aspect-square"
                    onImageUpload={(file) => onImageUpload(index, file)}
                    placeholder="Add Image"
                  />
                </div>
              );
            case "card":
              return (
                <div
                  key={widget?.id}
                  className={`relative animate-fade-slide-in shadow-md border-radius col-span-1 sm:col-span-2 lg:col-span-1`}
                >
                  <DeleteWidgetsIcon itemIndex={index} />
                  {/* Image Section */}
                  <div
                    className={`aspect-square border-radius p-2 sm:p-3 ${
                      !widget.s3key && "border"
                    }`}
                    style={{ borderColor: themeColor.text }}
                  >
                    <ImageUploader
                      className="h-full w-full flex justify-center items-center render-card-image-class"
                      CardImageUploaderStyle={true}
                      onImageUpload={(file) => onImageUpload(index, file)}
                      placeholder="Add Card Image"
                      key={`index-${index}`}
                      preview={widget?.s3key}
                      imagePreviewStyle="aspect-square rounded-2xl"
                    />
                  </div>

                  {/* Text Section */}
                  <div className="w-full px-3 sm:px-4 py-2 sm:py-3">
                    <EditableText
                      className="text-base sm:text-lg font-bold"
                      onEditDone={(e) =>
                        onWidgetEdit({
                          index,
                          key: "title",
                          value: e["title"],
                        })
                      }
                      name="title"
                      key="title"
                      placeholder="Card Title"
                      editModeOn={widget.isEditing}
                      autoFocus
                    >
                      {widget?.title}
                    </EditableText>
                    <EditableText
                      className="text-xs sm:text-sm"
                      onEditDone={(e) =>
                        onWidgetEdit({
                          index,
                          key: "subTitle",
                          value: e["subTitle"],
                        })
                      }
                      name="subTitle"
                      placeholder="Card Discription"
                      key="subTitle"
                    >
                      {widget?.subTitle}
                    </EditableText>
                  </div>
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};
